// before
import "@babel/polyfill";
// after
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import VueExcelXlsx from "vue-excel-xlsx"; //https://www.npmjs.com/package/vue-excel-xlsx
import Axios from 'axios'
import './plugins/axios';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import AudioRecorder from 'vue-audio-recorder';
import { Tabs, Tab } from 'vue-tabs-component';
import VueSimpleAlert from "vue-simple-alert";
import { PaginationPlugin } from 'bootstrap-vue';
Vue.use(PaginationPlugin);
Vue.use(VueExcelXlsx);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.config.productionTip = false;
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.use(AudioRecorder);
Vue.use(VueSimpleAlert);

import VueDictaphone from "vue-dictaphone";
Vue.use(VueDictaphone);

Vue.prototype.$http = Axios;
const token = store.state.token; //sessionStorage.getItem('token');
if (token) {
   // Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
